module.exports = __webpack_public_path__ + "44931772dc09d147cc0568ced706bf92.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_xlarge_x1/public/games/coh_image_2.png
// module id = 488
// module chunks = 0